import React, { useState, useMemo } from "react";
import Select from "./../Select";
import { Empty } from "antd";
import { SelectProps } from "antd/lib/select";
import { debounce, isEmpty, find, get } from "lodash";
import compact from "lodash/compact";
import categoryService from "./services/categoryService";
import { ICategory } from "./services/typings";
import useSWR from "swr";
import { useTranslation } from "react-i18next";

interface IProps extends SelectProps<any> {
  type?: "BOOKING" | "TRAFFIC";
  excludeIds?: string[];
  language?: "en" | "vn";
}

const CategorySelect = (props: IProps) => {
  const {
    value,
    onChange,
    type = "BOOKING",
    excludeIds,
    language = "en",
    ...rest
  } = props;
  const [searchText, setSearchText] = useState("");

  const { data, error } = useSWR(
    ["category_select"],
    () =>
      categoryService.getCategories({
        limit: 9999,
        offset: 0,
        // filters: [
        //   {
        //     field: "status",
        //     filter_name: "status",
        //     operator: null,
        //     type: "enum",
        //     value: ["ACTIVE"],
        //   },
        //   {
        //     field: "type",
        //     filter_name: "type",
        //     operator: null,
        //     type: "enum",
        //     value: [type],
        //   },
        // ],
      }),
    {
      refreshWhenHidden: false,
      revalidateOnFocus: false,
      refreshWhenOffline: false,
      revalidateOnReconnect: false,
    }
  );

  const categories = useMemo(() => data || [], [data]);
  const loading = isEmpty(data) && !error;

  const val = useMemo(
    () =>
      get(value, "cate_name_en") ||
      get(value, "cate_name_vn") ||
      get(value, "id"),
    [value]
  );

  const filteredCategories = useMemo(
    () =>
      compact([
        ...(categories || []),
        categories.length === 0 ? value : undefined,
      ]).filter(
        (s) =>
          (!searchText ||
            s?.cate_name_en
              ?.toLowerCase()
              .includes(searchText.toLowerCase())) &&
          !excludeIds?.includes(s?.id)
      ),
    [categories, searchText, value, excludeIds]
  );

  const debouncedSetSearchText = useMemo(
    () => debounce(setSearchText, 500),
    [setSearchText]
  );

  const handleOnChange = (val) => {
    const category = find(filteredCategories, (i) => i.id === val);
    if (onChange && category) {
      onChange(category, { value: category });
    }
  };

  const { t } = useTranslation();

  return (
    <Select
      placeholder={t("components.category_select.placeholder")}
      loading={loading}
      data={filteredCategories}
      onSearch={debouncedSetSearchText}
      notFoundContent={loading ? null : <Empty />}
      getDisplayText={(val: any) => val[`cate_name_${language}`]}
      getValue={(val: any) => val.id}
      showSearch
      filterOption={false}
      value={val}
      onChange={handleOnChange}
      {...rest}
    />
  );
};

export default React.memo(CategorySelect);
